import { FacebookSVG } from './assets/facebook';
import { YouTubeSVG } from './assets/youtube';
import { InstagramSVG } from './assets/instagram';
import { GiphySVG } from './assets/giphy';
import { TikTokSVG } from './assets/tiktok';
import { PinterestSVG } from './assets/pinterest';
export var socialIconData = {
    socialLinks: [
        {
            name: 'facebook',
            url: 'https://www.facebook.com/autotraderuk',
            svg: FacebookSVG,
            svgHeight: 20,
            svgWidth: 20,
            title: 'Facebook',
        },
        {
            name: 'youtube',
            url: 'https://www.youtube.com/user/autotraderuk?sub_confirmation=1',
            svg: YouTubeSVG,
            svgHeight: 14,
            svgWidth: 20,
            title: 'YouTube',
        },
        {
            name: 'instagram',
            url: 'https://www.instagram.com/autotraderuk',
            svg: InstagramSVG,
            svgHeight: 21,
            svgWidth: 20,
            title: 'Instagram',
        },
        {
            name: 'tiktok',
            url: 'https://www.tiktok.com/@autotraderuk',
            svg: TikTokSVG,
            svgHeight: 20,
            svgWidth: 18,
            title: 'TikTok',
        },
        {
            name: 'giphy',
            url: 'https://giphy.com/AutoTraderUK/',
            svg: GiphySVG,
            svgHeight: 20,
            svgWidth: 16,
            title: 'Giphy',
        },
        {
            name: 'pinterest',
            url: 'https://www.pinterest.co.uk/autotraderuk/',
            svg: PinterestSVG,
            svgHeight: 20,
            svgWidth: 20,
            title: 'Pinterest',
        },
    ],
};
